const DeleteIcon = () => {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4261 7.40417L11.0979 15.9424M6.55554 15.9424L6.2273 7.40417M15.6839 4.35887C16.0083 4.4082 16.3309 4.46038 16.6534 4.51635M15.6839 4.35887L14.6707 17.5296C14.6293 18.0658 14.3871 18.5666 13.9924 18.932C13.5977 19.2973 13.0796 19.5002 12.5418 19.5H5.11163C4.57382 19.5002 4.05576 19.2973 3.66106 18.932C3.26637 18.5666 3.02412 18.0658 2.98277 17.5296L1.96956 4.35887M15.6839 4.35887C14.5889 4.19334 13.4884 4.06771 12.3843 3.98224M1.96956 4.35887C1.64511 4.40725 1.32256 4.45943 1 4.5154M1.96956 4.35887C3.06448 4.19334 4.16506 4.06771 5.26912 3.98224M12.3843 3.98224V3.11323C12.3843 1.99378 11.521 1.06026 10.4015 1.02516C9.35193 0.991613 8.3015 0.991613 7.25188 1.02516C6.13243 1.06026 5.26912 1.99472 5.26912 3.11323V3.98224M12.3843 3.98224C10.0161 3.79921 7.63732 3.79921 5.26912 3.98224"
        stroke="#8492A6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
